<template>
  <div class="container">
    <Loading v-if="isFetching" />

    
    <div class="flex-container">
      <div class="col-filtres">
        <div class="bg-filtres">
          <h4>Filtres</h4>
          <Reset @reset="reset" />
          <RechercheCond @filtreRecherche="filtreRecherche" />
          <FiltreCond
            @filtreRegion="filtreRegion"
            @filtreFormation="filtreFormation"
            @filtreLangue="filtreLangue"
            @filtreEnLigne="filtreEnLigne"
          />
        </div>
      </div>
      <div class="col-afficher-cond" id="top-list">
        <div class="nombres-containter">
          <NombreResultatAfficher
            :formateurs="formateurs"
            :nbrResultats="nbrResultats"
            :isFetching="isFetching"
            ref="focusTargetCondTotal"
          />
          <NombrePageCourante
            :pageCourante="pageCourante"
            :nbrPages="nbrPages"
            :nbrResultats="nbrResultats"
            :nbrResultatsDernierePage="nbrResultatsDernierePage"
          />
        </div>
        <NombreResultatsParPage
          :nbrResultats="nbrResultats"
          @changerNombreResultatsParPage="changerNombreResultatsParPage"
        />
        <Formateurs
          :isFetching="isFetching"
          :formateurs="formateurs"
          :pageCourante="pageCourante"
          :nbrResultats="nbrResultats"
        />
        <div class="pagination" role="navigation">
          <PaginationPrincipal
            :formateurs="formateurs"
            :pageCourante="pageCourante"
            :nbrResultats="nbrResultats"
            :nbrPages="nbrPages"
            @nextPage="pageChangeHandle('next')"
            @previousPage="pageChangeHandle('previous')"
            @loadPage="pageChangeHandle"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import formateursData from "../public/ListeFormateurs.json"
import Loading from './components/Loading';
import FiltreCond from './components/Filtre_condamnation';
import RechercheCond from './components/Recherche_condamnation';
import Reset from './components/Reset_bouton';
import PaginationPrincipal from './components/Pagination_principal.vue';
import Formateurs from './components/Formateurs';
import NombreResultatAfficher from './components/Nombre_resultat_afficher';
import NombreResultatsParPage from './components/Nombre_resultat_par_page';
import NombrePageCourante from './components/Nombre_page_courante';

export default {
  name: 'App',
  components: {
    Loading,
    PaginationPrincipal,
    Formateurs,
    NombreResultatAfficher,
    NombreResultatsParPage,
    FiltreCond,
    RechercheCond,
    Reset,
    NombrePageCourante,
  },
  data() {
    return {
      type_condamnation: String,
      TousLesFormateurs: [],
      formateurs: [],
      nbrResultats: 10,
      nbrResultatsDernierePage: 0,
      pageCourante: 1,
      nbrPages: 0,
      bottom: false,
      isFetching: false,
      filtres: {
        Region_desservies: '',
        Type_de_formations_offertes: '',
        Langues_de_formation: '',
        IndicateurOffertEnLigne: '',
        motscles: '',
      },
    };
  },
  watch: {
    filtres: {
      handler: function () {
        this.filtreLesFormateurs();
      },
      deep: true,
    },
    condamnation(condamnation) {
      if (this.nbrResultats >= condamnation.length) {
        this.nbrResultats = condamnation.length;
      }
    },
  },
  methods: {
    async pageChangeHandle(value) {
      switch (value) {
        case 'next':
          this.pageCourante += 1;
          break;
        case 'previous':
          this.pageCourante -= 1;
          break;
        default:
          this.pageCourante = value;
      }
    },
    synonymesRegion() {
    return {
      'Saguenay-Lac-Saint-Jean': ['Saguenay–Lac-St-Jean', 'Saguenay - Lac-Saint-Jean'],
      'Gaspésie-Îles-de-la-Madeleine': ['Gaspésie-Îles-de-la-Madeleine', 'Gaspésie – île-de-la-Madelaine'],
      
      };
    },
    changerNombreResultatsParPage(nombreResultatsParPage) {
      this.nbrResultats = parseInt(nombreResultatsParPage);
      this.pageCourante = 1;
      this.filtreLesFormateurs();
    },
    filtreRegion(region) {
      this.filtres.Region_desservies = region;
      this.pageCourante = 1;
    },
    filtreFormation(formation) {
      this.filtres.Type_de_formations_offertes = formation;
      this.pageCourante = 1;
    },
    filtreLangue(langue) {
      this.filtres.Langues_de_formation = langue;
      this.pageCourante = 1;
    },
    filtreEnLigne(en_ligne) {
      if (en_ligne == true) {
        this.filtres.IndicateurOffertEnLigne = 'TRUE';
      } else {
        this.filtres.IndicateurOffertEnLigne = '';
      }
      this.pageCourante = 1;
    },
    filtreRecherche(motscles) {
      this.filtres.motscles = motscles;
      //ajout pour la pagination
      this.pageCourante = 1;
    },
    filtreLesFormateurs() {
      // On redéfinit les filtres ici parce qu'on ne peut pas accéder à this.filtres plus loin
      var filtresFormateurs = {
        Region_desservies: this.filtres.Region_desservies,
        Type_de_formations_offertes: this.filtres.Type_de_formations_offertes,
        Langues_de_formation: this.filtres.Langues_de_formation,
        IndicateurOffertEnLigne: this.filtres.IndicateurOffertEnLigne,
        motscles: this.filtres.motscles,
      };

      // On filtre chaque formateur
      this.formateurs = this.TousLesFormateurs.filter((formateur) => {


  let nomComplet;

  for (const key in filtresFormateurs) {
    const valeurFiltre = filtresFormateurs[key];

    if (valeurFiltre) {
      // Si le filtre est mots clés
      if (key === 'motscles') {
        if (formateur.Prenom && formateur.Nom) {
          nomComplet = `${formateur.Prenom} ${formateur.Nom}`;
        } else if (formateur.Nom) {
          nomComplet = formateur.Nom;
        } else if (formateur.Prenom) {
          nomComplet = formateur.Prenom;
        }

        const motcle = valeurFiltre.toLowerCase();
        const nomMatch = nomComplet?.toLowerCase().includes(motcle);
        const etabMatch = formateur.Etablissement?.toLowerCase().includes(motcle);

        if (!nomMatch && !etabMatch) {
          return false;
        }
      }

      // Cas spécifique pour les régions avec synonymes
      else if (key === 'Region_desservies') {
        const regionDemandee = valeurFiltre.trim();
        const variantes = [regionDemandee, ...(this.synonymesRegion()[regionDemandee] || [])];

        const match = variantes.some((val) => formateur[key]?.includes(val));
        if (!match) return false;
      }

      // Autres filtres classiques
      else {
        if (!formateur[key]?.includes(valeurFiltre)) {
          return false;
        }
      }
    }
  }

  return true; // <=== fin du .filter
});

      //ajout pour la pagination
      this.nbrPages = Math.ceil(this.formateurs.length / this.nbrResultats);

      // Calculons le nombre de résultats dans la dernière page
      this.calculerNbrResultatsDernierePage();
    },
    changeNbrResultat() {
      let nbrTotal = this.condamnation.length;
      let nbrRestants = nbrTotal - this.nbrResultats - 20;
      if (nbrTotal >= this.nbrResultats) {
        this.nbrResultats = this.nbrResultats + 20;
      }
      if (nbrRestants <= 0) {
        this.nbrResultats = nbrTotal;
      }
    },
    calculerNbrResultatsDernierePage() {
      // Calculons le nombre de résultats à la dernière page
      // Mettons qu'on a 362 résultats, 37 pages et on veut 10 résultats par page
      // Donc : 36 pages de 10 résultats et une 37e page avec 2 résultats
      // Formule : (Nombre de formateurs) - ((nombre de pages - 1) * nombre de résultats par page)
      // 362 - ((37 - 1) * 10)
      // 362 - ((36) * 10)
      // 362 - 360
      // = 2
      // Donc 2 résultats à la dernière page
      this.nbrResultatsDernierePage =
        this.formateurs.length - (this.nbrPages - 1) * this.nbrResultats;
    },
    reset() {
      // Reset data
      this.filtres.Region_desservies = '';
      this.filtres.Type_de_formations_offertes = '';
      this.filtres.Langues_de_formation = '';
      this.filtres.IndicateurOffertEnLigne = '';
      this.filtres.motscles = '';

      // Reset in DOM
      document.getElementById('recherche_par_mots_cles').value = '';
      document.getElementById('filtre_par_region').value = '';
      document.getElementById('filtre_par_formation').value = '';
      document.getElementById('filtre_par_langue').value = '';
      document.getElementById('filtre_en_ligne').checked = false;
      document.getElementById('bouton_reset_input').style.display="none";
    },
  },
  created() {
    // Fetching all the data
    fetch('./ListeFormateurs.json')
      .then((res) => res.json())
      .then((data) => {
        // On assigne la réponse à TousLesFormateurs
        //this.TousLesFormateurs = data.formateurs;
        this.TousLesFormateurs = data.formateurs.filter(
          (r) =>
            r.Statut_actif == 'oui'
        ); // Alimentation
        // On les affiche tous en ordre "random"
        this.formateurs = this.TousLesFormateurs.sort(
          () => Math.random() - 0.5
        );

        // Caculate the number of pages
        this.nbrPages = Math.ceil(this.formateurs.length / 10);

        // Calculons le nombre de résultats dans la dernière page
        this.calculerNbrResultatsDernierePage();
      });
  },
};
</script>

<style></style>
